import { render, staticRenderFns } from "./MultipleQuestion.vue?vue&type=template&id=c8823a74&scoped=true"
import script from "./MultipleQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultipleQuestion.vue?vue&type=style&index=0&id=c8823a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8823a74",
  null
  
)

export default component.exports